/**
 * HSK模拟考
 */

/**
 * pt 听力--判断听到的内容与图片是否相符
 * pw 阅读---判断对错
 * ps 阅读---判断句子对错（有拼音）
 * xp 听力---选出与听到内容相符的图片
 * xw 听力---选出与听到内容相符的文字
 * xt 听力---选出与听到内容相符的图片-套题
 * ct 阅读---看句子选择题（文本）
 * cl 阅读---看句子选择题（文本）(有拼音)
 * wt 阅读---选择对应图片-套题
 * ww 阅读---选择对应文本-套题
 * tt 阅读---选择正确的词语填入设空处，是句子正确。-套题
 * tp 写作---选择正确的偏旁填入设空处，使词语正确。-套题
 * ws 阅读---选择对应句子（套）（无拼音）
 * cw 书写---连词成句
 * ph 书写---看拼音写汉字
 *
 * lt 听力---选择套题带大题题干
 * rt 阅读---选择套题带大题题干
 * so 阅读---句子排序
 * ms 书写---看图造句
 * kw 书写---根据关键词写短文
 * pa 书写---根据图片写短文
 * ls 阅读---选择有语病的一项
 * sx 书写---缩写
 * rs 阅读---选句填空（带图片）
 */

/**
 * HSK7-9新题型
 *
 * pr 听力---判断句子对错套题带大题题干，小题文字题干
 * lr 听力---选择与填空混合套题带大题题干，小题音频题干
 * rr 阅读---套题主观回答文章问题
 * pu 写作---根据材料写作
 * tr 翻译---根据文章进行笔译
 * ts 翻译---根据段落口译，带引导音频，
 * ky 口语---根据材料录音，带引导音频
 * kt 口语---套题根据音频录音
 *
 */
export const HSK_RESOURCE_TYPE = {
  typeOfJudgmentListenPic: 'pt',
  typeOfJudgmentReadPic: 'pw',
  typeOfJudgmentReadSentence: 'ps',
  typeOfSelectListenPic: 'xp',
  typeOfSelectListenText: 'xw',
  typeOfSetOfSelectListenPic: 'xt',
  typeOfSelectReadText: 'ct',
  typeOfSelectReadSentence: 'cl',
  typeOfSetOfSelectReadPic: 'wt',
  typeOfSetOfSelectReadText: 'ww',
  typeOfSetOfSelectReadTextBlank: 'tt',
  typeOfSetOfSelectWriteTextBlank: 'tp',
  typeOfSetOfSelectReadSentence: 'ws',
  typeOfWriteJoinSentence: 'cw',
  typeOfWriteText: 'ph',
  typeOfWriteTextPy: 'py',

  typeOfSetChooseTextByVoice: 'lt',
  typeOfSetReadChooseTextBySentence: 'rt',
  typeOfReadingOrder: 'so',
  typeOfWriteSentensePic: 'ms',
  typeOfWriteArticalKeywords: 'kw',
  typeOfWriteArticalPic: 'pa',
  typeOfReadingComprehension: 'ls',
  typeOfWriteAbbreviation: 'sx',
  typeOfSetReadChooseTextFillBlank: 'rs',

  // 通用题型
  typeOfFillBlankEH: 'eh', // eh填空题
  typeofSpeechEvaluatingEK: 'ek', //ek字词句评测
  typeOfCommonChoose: 'eb', //通用选择
  typeOfCommonSetChoose: 'ea', //通用套题选择
  typeofSortForEF: 'ef', // 通用连词成句
  typeofJudge: 'ec', // 判断题
  typeofSortForEE: 'ee', // 句子排序
}
// 等级介绍-例题使用
export const HSK_COMMPONENTS = {
  [HSK_RESOURCE_TYPE.typeOfJudgmentListenPic]: 'Judgment',
  [HSK_RESOURCE_TYPE.typeOfJudgmentReadPic]: 'Judgment',
  [HSK_RESOURCE_TYPE.typeOfJudgmentReadSentence]: 'Judgment',
  [HSK_RESOURCE_TYPE.typeOfSelectListenPic]: 'SelectPicByVoice',
  [HSK_RESOURCE_TYPE.typeOfSelectListenText]: 'SelectTextByVoice',
  [HSK_RESOURCE_TYPE.typeOfSelectReadText]: 'SelectTextByVoice',
  [HSK_RESOURCE_TYPE.typeOfSelectReadSentence]: 'SelectSentenceByVoice',
  [HSK_RESOURCE_TYPE.typeOfSetOfSelectReadPic]: 'SetChoosePicByText',
  [HSK_RESOURCE_TYPE.typeOfSetOfSelectListenPic]: 'SetChoosePicByVoice',
  [HSK_RESOURCE_TYPE.typeOfSetOfSelectReadText]: 'SetChooseTextByText',
  [HSK_RESOURCE_TYPE.typeOfSetOfSelectReadTextBlank]: 'SetChooseTextByText',
  [HSK_RESOURCE_TYPE.typeOfSetOfSelectWriteTextBlank]: 'SelectChoosePicByText',
  [HSK_RESOURCE_TYPE.typeOfSetOfSelectReadSentence]: 'SetChooseTextByText',
  [HSK_RESOURCE_TYPE.typeOfWriteJoinSentence]: 'JoinSentence',
  [HSK_RESOURCE_TYPE.typeOfWriteText]: 'FillInBlank',
  [HSK_RESOURCE_TYPE.typeOfWriteTextPy]: 'FillInBlankPy',

  [HSK_RESOURCE_TYPE.typeOfSetChooseTextByVoice]: 'SetChooseTextByVoice',
  [HSK_RESOURCE_TYPE.typeOfSetReadChooseTextBySentence]: 'SetReadChooseTextBySentence',
  [HSK_RESOURCE_TYPE.typeOfReadingOrder]: 'ReadingOrder',
  [HSK_RESOURCE_TYPE.typeOfWriteSentensePic]: 'MakeSentence',
  [HSK_RESOURCE_TYPE.typeOfWriteArticalKeywords]: 'MakeSentence',
  [HSK_RESOURCE_TYPE.typeOfWriteArticalPic]: 'MakeSentence',
  [HSK_RESOURCE_TYPE.typeOfReadingComprehension]: 'SelectTextReadingComprehension',
  [HSK_RESOURCE_TYPE.typeOfWriteAbbreviation]: 'Abbreviation',
  [HSK_RESOURCE_TYPE.typeOfSetReadChooseTextFillBlank]: 'SetReadChooseTextFillBlank',

  // 通用题型
  [HSK_RESOURCE_TYPE.typeOfFillBlankEH]: 'CommonWriteFillBlank',
  [HSK_RESOURCE_TYPE.typeofSpeechEvaluatingEK]: 'CommonSpeechEvaluating',
  [HSK_RESOURCE_TYPE.typeOfCommonChoose]: 'CommonChoice',
  [HSK_RESOURCE_TYPE.typeOfCommonSetChoose]: 'CommonReadingComprehension',
  [HSK_RESOURCE_TYPE.typeofSortForEF]: 'CommonSortConjunctionPrimary',
  [HSK_RESOURCE_TYPE.typeofJudge]: 'CommonJudgment',
  [HSK_RESOURCE_TYPE.typeofSortForEE]: 'CommonSortSentence',
}
// 全仿真-未使用
export const HSK_SIMULATION_RESOURCE_TYPE = {
  typeOfJudgmentListenPic: 'pt',
  typeOfJudgmentReadPic: 'pw',
  typeOfJudgmentReadSentence: 'ps',
  typeOfSelectListenPic: 'xp',
  typeOfSelectListenText: 'xw',
  typeOfSetOfSelectListenPic: 'xt',
  typeOfSelectReadText: 'ct',
  typeOfSelectReadSentence: 'cl',
  typeOfSetOfSelectReadPic: 'wt',
  typeOfSetOfSelectReadText: 'ww',
  typeOfSetOfSelectReadTextBlank: 'tt',
  typeOfSetOfSelectWriteTextBlank: 'tp',
  typeOfSetOfSelectReadSentence: 'ws',
  typeOfWriteJoinSentence: 'cw',
  typeOfWriteText: 'ph',
  typeOfWriteTextPy: 'py',

  typeOfSetChooseTextByVoice: 'lt',
  typeOfSetReadChooseTextBySentence: 'rt',
  typeOfReadingOrder: 'so',
  typeOfWriteSentensePic: 'ms',
  typeOfWriteArticalKeywords: 'kw',
  typeOfWriteArticalPic: 'pa',
  typeOfReadingComprehension: 'ls',
  typeOfWriteAbbreviation: 'sx',
  typeOfSetReadChooseTextFillBlank: 'rs',

  // HSK7-9 新题型
  typeOfSetJudgmentByVoice: 'pr',
  typeOfSetChooseOrInputByVoice: 'lr',
  typeOfsetReadSubjectiveAnswer: 'rr',
  typeOfWriteArticalPicOrSentense: 'pu',
  typeOfTranslateByArtical: 'tr',
  typeOfTranslateRecordByVoice: 'ts', // 根据材料口译
  typeOfSpeakingRecordByVoice: 'ky',//
  typeOfSetSpeakingRecordByVoice: 'kt',

  // hskk题型
  typeOfSpeakingRecordByVoiceHskkThcf: 'thcf',//
  typeOfSpeakingRecordByVoiceHskkThhd: 'thhd',//
  typeOfSpeakingRecordByVoiceHskkKtsh: 'ktsh',//
  typeOfSpeakingRecordByVoiceHskkHdwt: 'hdwt',//
  typeOfSpeakingRecordByVoiceHskkLdld: 'ldld',//
  typeOfSpeakingRecordByVoiceHskkCommon: 'tyhskk',//

  // 通用题型
  typeOfFillBlankEH: 'eh', // eh填空题
  typeofSpeechEvaluatingEK: 'ek', //ek字词句评测
  typeOfCommonChoose: 'eb', //通用选择
  typeOfCommonSetChoose: 'ea', //通用套题选择
  typeofSortForEF: 'ef', // 通用连词成句
  typeofJudge: 'ec', // 判断题
  typeofSortForEE: 'ee', // 句子排序
}
// 考试流程&试卷预览
export const HSK_SIMULATION_COMPONENTS = {
  [HSK_SIMULATION_RESOURCE_TYPE.typeOfJudgmentListenPic]: 'Judgment',
  [HSK_SIMULATION_RESOURCE_TYPE.typeOfJudgmentReadPic]: 'Judgment',
  [HSK_SIMULATION_RESOURCE_TYPE.typeOfJudgmentReadSentence]: 'Judgment',
  [HSK_SIMULATION_RESOURCE_TYPE.typeOfSelectListenPic]: 'SelectPicByVoice',
  [HSK_SIMULATION_RESOURCE_TYPE.typeOfSelectListenText]: 'SelectTextByVoice',
  [HSK_SIMULATION_RESOURCE_TYPE.typeOfSelectReadText]: 'SelectTextByVoice',
  [HSK_SIMULATION_RESOURCE_TYPE.typeOfSelectReadSentence]: 'SelectSentenceByVoice',
  [HSK_SIMULATION_RESOURCE_TYPE.typeOfSetOfSelectReadPic]: 'SetChoosePicByText',
  [HSK_SIMULATION_RESOURCE_TYPE.typeOfSetOfSelectListenPic]: 'setChoosePicByVoiceSimulation',
  [HSK_SIMULATION_RESOURCE_TYPE.typeOfSetOfSelectReadText]: 'SetChooseTextByText',
  [HSK_SIMULATION_RESOURCE_TYPE.typeOfSetOfSelectReadTextBlank]: 'SetChooseTextByText',
  [HSK_SIMULATION_RESOURCE_TYPE.typeOfSetOfSelectWriteTextBlank]: 'SelectChoosePicByText',
  [HSK_SIMULATION_RESOURCE_TYPE.typeOfSetOfSelectReadSentence]: 'SetChooseTextByText',
  [HSK_SIMULATION_RESOURCE_TYPE.typeOfWriteJoinSentence]: 'JoinSentence',
  [HSK_SIMULATION_RESOURCE_TYPE.typeOfWriteText]: 'FillInBlank',
  [HSK_SIMULATION_RESOURCE_TYPE.typeOfWriteTextPy]: 'FillInBlankPy',

  [HSK_SIMULATION_RESOURCE_TYPE.typeOfSetChooseTextByVoice]: 'setChooseTextByVoiceSimulation',
  [HSK_SIMULATION_RESOURCE_TYPE.typeOfSetReadChooseTextBySentence]: 'SetReadChooseTextBySentence',
  [HSK_SIMULATION_RESOURCE_TYPE.typeOfReadingOrder]: 'ReadingOrder',
  [HSK_SIMULATION_RESOURCE_TYPE.typeOfWriteSentensePic]: 'MakeSentence',
  [HSK_SIMULATION_RESOURCE_TYPE.typeOfWriteArticalKeywords]: 'MakeSentence',
  [HSK_SIMULATION_RESOURCE_TYPE.typeOfWriteArticalPic]: 'MakeSentence',
  [HSK_SIMULATION_RESOURCE_TYPE.typeOfReadingComprehension]: 'SelectTextReadingComprehension',
  [HSK_SIMULATION_RESOURCE_TYPE.typeOfWriteAbbreviation]: 'abbreviationSimulation',
  [HSK_SIMULATION_RESOURCE_TYPE.typeOfSetReadChooseTextFillBlank]: 'SetReadChooseTextFillBlank',

  [HSK_SIMULATION_RESOURCE_TYPE.typeOfSetJudgmentByVoice]: 'setJudgmentByVoiceSimulation',
  [HSK_SIMULATION_RESOURCE_TYPE.typeOfSetChooseOrInputByVoice]: 'setChooseOrInputByVoice',
  [HSK_SIMULATION_RESOURCE_TYPE.typeOfsetReadSubjectiveAnswer]: 'setReadSubjectiveAnswer',
  [HSK_SIMULATION_RESOURCE_TYPE.typeOfWriteArticalPicOrSentense]: 'countDownMakeSentence',
  [HSK_SIMULATION_RESOURCE_TYPE.typeOfTranslateByArtical]: 'countDownMakeSentence',
   [HSK_SIMULATION_RESOURCE_TYPE.typeOfTranslateRecordByVoice]: 'recordByVoice',
  [HSK_SIMULATION_RESOURCE_TYPE.typeOfSpeakingRecordByVoice]: 'recordByVoice',
  [HSK_SIMULATION_RESOURCE_TYPE.typeOfSetSpeakingRecordByVoice]: 'recordByVoice',

  //hskk题型
  [HSK_SIMULATION_RESOURCE_TYPE.typeOfSpeakingRecordByVoiceHskkThcf]: 'recordByVoiceHskk',
  [HSK_SIMULATION_RESOURCE_TYPE.typeOfSpeakingRecordByVoiceHskkThhd]: 'recordByVoiceHskk',
  [HSK_SIMULATION_RESOURCE_TYPE.typeOfSpeakingRecordByVoiceHskkKtsh]: 'recordByVoiceHskk',
  [HSK_SIMULATION_RESOURCE_TYPE.typeOfSpeakingRecordByVoiceHskkHdwt]: 'recordByVoiceHskk',
  [HSK_SIMULATION_RESOURCE_TYPE.typeOfSpeakingRecordByVoiceHskkLdld]: 'recordByVoiceHskk',
  [HSK_SIMULATION_RESOURCE_TYPE.typeOfSpeakingRecordByVoiceHskkCommon]: 'recordByVoiceHskk',

  // 通用题型
  [HSK_SIMULATION_RESOURCE_TYPE.typeOfFillBlankEH]: 'CommonWriteFillBlank',
  [HSK_SIMULATION_RESOURCE_TYPE.typeofSpeechEvaluatingEK]: 'CommonSpeechEvaluating',
  [HSK_SIMULATION_RESOURCE_TYPE.typeOfCommonChoose]: 'CommonChoice',
  [HSK_SIMULATION_RESOURCE_TYPE.typeOfCommonSetChoose]: 'CommonReadingComprehension',
  [HSK_SIMULATION_RESOURCE_TYPE.typeofSortForEF]: 'CommonSortConjunctionPrimary',
  [HSK_SIMULATION_RESOURCE_TYPE.typeofJudge]: 'CommonJudgment',
  [HSK_SIMULATION_RESOURCE_TYPE.typeofSortForEE]: 'CommonSortSentence',
}

// 通用测题型
// 拼音-听力判断-判断
// 拼音-听力选择-选择
// 语音评测
// 连词成句
// 判断
// 选择
// 选择-无题干
// 未使用
export const COMMON_RESOURCE_TYPE = {
  typeOfFillBlankEH: 'eh', // eh填空题
  typeofSpeechEvaluatingEK: 'ek', //ek字词句评测
  typeofSpeechEvaluatingEJ: 'ej',
  typeofSpeechEvaluatingEL: 'el',
  typeOfCommonChoose: 'eb', //通用选择
  typeOfCommonSetChoose: 'ea', //通用套题选择
  typeofSortForEF: 'ef', // 通用连词成句
  typeofJudge: 'ec', // 判断题
  typeofSortForEE: 'ee', // 句子排序
}

export const COMMON_COMPONENTS = {
  [COMMON_RESOURCE_TYPE.typeOfFillBlankEH]: 'CommonWriteFillBlank',
  [COMMON_RESOURCE_TYPE.typeofSpeechEvaluatingEK]: 'CommonSpeechEvaluating',
  [COMMON_RESOURCE_TYPE.typeofSpeechEvaluatingEJ]: 'CommonSpeechEvaluating',
  [COMMON_RESOURCE_TYPE.typeofSpeechEvaluatingEL]: 'CommonSpeechEvaluating',
  [COMMON_RESOURCE_TYPE.typeOfCommonChoose]: 'CommonChoice',
  [COMMON_RESOURCE_TYPE.typeOfCommonSetChoose]: 'CommonReadingComprehension',
  [COMMON_RESOURCE_TYPE.typeofSortForEF]: 'CommonSortConjunctionPrimary',
  [COMMON_RESOURCE_TYPE.typeofJudge]: 'CommonJudgment',
  [COMMON_RESOURCE_TYPE.typeofSortForEE]: 'CommonSortSentence',
}

export const MARK_RESULT_TYPE = {
  typeOfWriteSxCommon: 'sx', // 缩写
  typeOfWritePaCommon: 'pa', // 写短文
  typeOfWriteKwCommon: 'kw', // 写短文
  typeOfWriteMsCommon: 'ms', // 看图用词造句
  // 7-9
  typeOfListenLrCommon: 'lr', // 听力套题,选择填空混合题型
  typeOfReadRrCommon: 'rr', //阅读套题,主观回答
  typeOfWritePuCommon: 'pu',//根据材料写作

  typeOfTranslateTrCommon: 'tr',// 根据材料笔译
  typeOfTranslateTsCommon: 'ts', // 根据材料口译
  typeOfSpeakingKyCommon: 'ky', // 口语单题
  typeOfSpeakingKtCommon: 'kt', // 口语套题

  // hskk
  typeOfSpeakingKyCommonHskk: 'tyhskk', // 口语单题
  typeOfSpeakingKtCommonHskk: 'ldld' // 口语套题
}
export const MARK_RESULT_COMPONENT = {
  [MARK_RESULT_TYPE.typeOfWriteSxCommon]: 'CommonWriteSxResult',
  [MARK_RESULT_TYPE.typeOfWritePaCommon]: 'CommonWritePaResult',
  [MARK_RESULT_TYPE.typeOfWriteKwCommon]: 'CommonWriteKwResult',
  [MARK_RESULT_TYPE.typeOfWriteMsCommon]: 'CommonWriteMsResult',
  // 7-9
  [MARK_RESULT_TYPE.typeOfListenLrCommon]: 'CommonListenLrResult',
  [MARK_RESULT_TYPE.typeOfReadRrCommon]: 'CommonReadRrResult',
  [MARK_RESULT_TYPE.typeOfWritePuCommon]: 'CommonWritePuResult',
  [MARK_RESULT_TYPE.typeOfTranslateTrCommon]: 'CommonWritePuResult',
  [MARK_RESULT_TYPE.typeOfTranslateTsCommon]: 'CommonSpeakingKtResult',
  [MARK_RESULT_TYPE.typeOfSpeakingKyCommon]: 'CommonTranslationTsResult',
  [MARK_RESULT_TYPE.typeOfSpeakingKtCommon]: 'CommonSpeakingKtResult',
  // hskk
  [MARK_RESULT_TYPE.typeOfSpeakingKyCommonHskk]: 'CommonSpeakingTyResult',
  [MARK_RESULT_TYPE.typeOfSpeakingKtCommonHskk]: 'CommonSpeakingLdldResult',
}
